import { FrameStencil, HandoffAction, MarkerBall, MarkerPlayer, MovementType, StencilType } from "../../../types";
import { sliceItemUpdate } from "../../splice-item";
import { isHandoffAction, isPlayer } from "../frame-stencil-filters";
import { refreshMovements } from "../refresh-movements";

export interface AddBallProps {
  ball: MarkerBall;
  stencils: FrameStencil[];
}

export const addBall = ({ ball, stencils }: AddBallProps): FrameStencil[] => {
  const associatedPlayer = stencils.find((s): s is MarkerPlayer => s.id === ball.associatedPlayer && isPlayer(s));

  /** add closest action to ball's movements */
  const ballWithClosestAction: MarkerBall = {
    ...ball,
    ...(associatedPlayer && {
      movements: [{ id: associatedPlayer.id, movementType: MovementType.POSSESSION, startTime: 0 }],
    }),
  };

  /** Check if associated player is receiving a handoff */
  const stencilsWithUpdatedHandoff = (() => {
    if (!associatedPlayer) return stencils;

    const handoff = stencils.find(
      (s): s is HandoffAction =>
        s.stencilType === StencilType.ACTION && isHandoffAction(s) && s.nextPlayer === associatedPlayer.id
    );

    if (!handoff) return stencils;

    return sliceItemUpdate({
      item: {
        ...handoff,
        nextPlayer: null,
        endPos: handoff.pos,
        prevPlayer: associatedPlayer.id,
        startPos: associatedPlayer.pos,
      },
      arr: stencils,
    });
  })();

  const stencilsWithBall = refreshMovements([...stencilsWithUpdatedHandoff, ballWithClosestAction]);

  return stencilsWithBall;
};
